/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  ⚠️ [C2b §4b] TWO KINDS OF ARRANGEMENT GROUP, AND THEY BEHAVE OPPOSITELY ON ARCHIVE.
 *
 *  `MANUAL` is [P3b.1]'s "Group these" — a band a person drew, whose members are related by
 *  nothing but somebody's judgement, and which SHRINKS when a member is archived.
 *  `CORRIGENDUM` is a parent and its amendments: cancelling the parent cancels them, filing
 *  needs the WHOLE group elapsed, and a duty in progress on EITHER refuses both.
 *
 *  ⚠️ IT IS A KIND ON THE EXISTING ENTITY RATHER THAN A NEW ONE, which is §4b's instruction
 *  ("do not introduce a parallel concept"). [P3b] built this model for exactly this shape and
 *  left its print question open — a corrigendum printing as its own sheet (§4j) is that
 *  question answered, and it needs no new column because a member IS a real arrangement.
 *
 *  ⚠️ IT LIVES IN `constants/` RATHER THAN IN EITHER SCHEMA, and that is forced rather than
 *  stylistic: `arrangementGroup.schema.ts` already imports FROM `arrangement.schema.ts`, and
 *  `arrangementGroupRefSchema` — which lives in the second — needs this tuple. A tuple of
 *  strings imports no zod, so `constants/` can hold it and neither schema has to import the
 *  other. `officerApp.constant.ts` was split out for exactly this reason.
 * ─────────────────────────────────────────────────────────────────────────────────
 */

export const ARRANGEMENT_GROUP_KINDS = ['MANUAL', 'CORRIGENDUM'] as const;

export type ArrangementGroupKind = (typeof ARRANGEMENT_GROUP_KINDS)[number];

/**
 * ⚠️ WHAT ONE ORDER IS *WITHIN* ITS GROUP. `MEMBER` on a manual band.
 *
 * A reader needs to know whether they are looking at the original or an amendment before they
 * can read the numbers on the screen correctly — §4d keeps every count per-arrangement, so the
 * relationship is the only thing that explains why one order asks for 50 and its neighbour 12.
 */
export const ARRANGEMENT_GROUP_ROLES = ['PARENT', 'CORRIGENDUM', 'MEMBER'] as const;

export type ArrangementGroupRole = (typeof ARRANGEMENT_GROUP_ROLES)[number];
